// Shared helpers for the analytics / forecasting dashboard.

export const buildParams = (base = {}, extra = {}) => {
    const params = new URLSearchParams();
    const merged = { ...base, ...extra };
    Object.entries(merged).forEach(([key, value]) => {
        if (value === undefined || value === null || value === "") return;
        params.set(key, String(value));
    });
    return params;
};

export const fmtNumber = (n) =>
    Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 });

export const fmtCurrency = (n) =>
    `$${Number(n || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}`;

export const fmtCompactCurrency = (n) => {
    const value = Number(n || 0);
    if (Math.abs(value) >= 1000) {
        return `$${(value / 1000).toLocaleString(undefined, { maximumFractionDigits: 1 })}k`;
    }
    return fmtCurrency(value);
};

export const fmtPct = (n) => {
    const value = Number(n || 0);
    const sign = value > 0 ? "+" : "";
    return `${sign}${value.toFixed(1)}%`;
};

export const TREND_META = {
    up: { icon: "fa-arrow-trend-up", cls: "text-green-600 bg-green-50", label: "Rising" },
    down: { icon: "fa-arrow-trend-down", cls: "text-red-600 bg-red-50", label: "Falling" },
    flat: { icon: "fa-arrow-right-long", cls: "text-slate-500 bg-slate-100", label: "Stable" },
};

export const STATUS_META = {
    reorder: { label: "Reorder now", cls: "bg-red-100 text-red-700", icon: "fa-triangle-exclamation" },
    overstock: { label: "Overstock", cls: "bg-amber-100 text-amber-700", icon: "fa-layer-group" },
    dead_stock: { label: "Dead stock", cls: "bg-slate-200 text-slate-600", icon: "fa-ban" },
    ok: { label: "Healthy", cls: "bg-green-100 text-green-700", icon: "fa-check" },
};

export const ABC_META = {
    A: "bg-purple-100 text-purple-700",
    B: "bg-blue-100 text-blue-700",
    C: "bg-slate-100 text-slate-600",
};

export const METHOD_LABELS = {
    holt_linear: "Holt trend",
    exponential_smoothing: "Exp. smoothing",
    moving_average: "Moving avg",
    none: "No data",
};

export const downloadBlob = (response, filename) => {
    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url);
};

export const CHART_COLORS = {
    blue: "#0085db",
    purple: "#5f2dde",
    green: "#22c55e",
    red: "#DB2426",
    amber: "#f59e0b",
    slate: "#64748b",
};

export const MONTH_OPTIONS = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
];
